import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthContext";
import { api } from "../api/clientInstance";
import "./LanguageSelector.css";

const LANGUAGES = [
  { code: "en", flag: "🇬🇧", label: "English" },
  { code: "es", flag: "🇪🇸", label: "Español" },
  { code: "pt", flag: "🇵🇹", label: "Português" },
];

export function LanguageSelector() {
  const { i18n } = useTranslation();
  const { user, setUser } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const current = LANGUAGES.find((l) => l.code === i18n.language) ?? LANGUAGES[0];

  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const handleSelect = async (code) => {
    setOpen(false);
    i18n.changeLanguage(code);
    if (user) {
      try {
        const updated = await api("/user/me/locale", { method: "PATCH", body: JSON.stringify({ locale: code }) });
        setUser(updated);
      } catch (e) {
        console.error("Failed to persist locale", e);
      }
    }
  };

  return (
    <div ref={ref} className="lang-selector">
      <button className="lang-trigger" onClick={() => setOpen((o) => !o)} title={current.label}>
        {current.flag}
      </button>
      {open && (
        <div className="lang-dropdown">
          {LANGUAGES.map(({ code, flag, label }) => (
            <button
              key={code}
              className={`lang-option ${code === i18n.language ? "active" : ""}`}
              title={label}
              onClick={() => handleSelect(code)}
            >
              {flag}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
